export default __webpack_public_path__ + "static/char-v-07-cbefd32d7a2a3b28f0b846eb340ac0f8.mp4";